<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>今日分销者黑榜</div>
    </div>
    <dv-scroll-board :config="config" class="panel-item_datav"/>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      config: {
        header: ['排名', '分销者名称', '付款金额', '付款订单'],
        data: [],
        headerBGC: '#053355',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        headerHeight: 30,
        rowNum: 5, // 可以控制显示的行数，间接影响行高表现
        hoverPause: true,
        // waitTime: 99999999,
        align: ['left', 'center', 'center', 'center'],
        columnWidth: [60,] // 调整列宽，中间列为产品名称宽度

      },
      detailVisible: false,
      detail: {},

    }
  },
  mounted() {
  },
  methods: {},
// 修改 watch 中的 datas 处理逻辑
  watch: {
    datas: {
      immediate: true,
      handler(newVal) {
        const newData = newVal.map((item, index) => [
          `<div class="index${index} left_box">${index > 2 ? index + 1 : ''}</div>`,
          // 为产品名称添加 title 属性，鼠标悬浮时显示完整名称
          `<div title="${item.user_nickname || ''}">${item.user_nickname || ''}</div>`,
          `<div>${item.sum_pay_amount}</div>`,
          `<div class="right_box" >${item.count_order || '0'}</div>`
        ])

        this.config = Object.assign({}, this.config, {
          data: newData
        })
      }
    },
  }

}
</script>

<style lang="scss" scoped>

.panel-item {
  width: 100%;
  height: 320px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  .title_name {
    padding: 18px 0 10px 18%;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }

  .panel-item_datav {
    padding: 0 30px 30px 30px;
    width: calc(100% - 60px);
    height: 220px;
  }

}


//表头
::v-deep .header-item {
  font-size: 18px;
}

//单行
::v-deep .row-item {
  font-size: 18px;
  border-bottom: 1px dashed rgba(255, 255, 255, .2);
}

::v-deep .ceil {
  text-align: center;
}

// 排名
::v-deep .left_box {
  line-height: 30px !important;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking.png) no-repeat;
  background-size: 30px 30px;
}


::v-deep .index0 {
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking1.png) no-repeat !important;
  background-size: 30px 30px !important;
}

::v-deep .index1 {
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking2.png) no-repeat !important;
  background-size: 30px 30px !important;
}

::v-deep .index2 {
  line-height: 30px;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking3.png) no-repeat !important;
  background-size: 30px 30px !important;
}

// 数量
::v-deep .right_box {
  width: 50%;
  height: 24px;
  line-height: 24px;
  background: #00BAFF;
  font-weight: bold;
  color: #06162A;
  transform: translate(50%, 40%);
}
</style>